<div class="row clearfix">
  <div class="col-md-12">
    <div class="card">
      <div class="header">
        <h2>Filtro</h2>
      </div>
      <div class="body">
        <div class="row">

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Filtrando por:</mat-label>
              <mat-select [(ngModel)]="search.field">
                <mat-option value="nome">Nome Contato</mat-option>
                <mat-option value="usuarioResponsavel.nome">Usuario Responsável</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Tipo Filtro</mat-label>
              <mat-select [(ngModel)]="search.option">
                <mat-option *ngFor="let option of filterOptions" [value]="option.value">{{option.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Pesquisar por</mat-label>
              <input matInput type="text" [(ngModel)]="search.searchTerm" (keyup.enter)="filter()" />
              <mat-error>Informe um titulo válido.</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Status do Contato</mat-label>
              <mat-select [(ngModel)]="searchStatus.searchTerm">
                <mat-option value="">Todos</mat-option>
                <mat-option *ngFor="let status of typesService.contatoStatusType" [value]="status.value">{{status.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Filtrando Data por:</mat-label>
              <mat-select [(ngModel)]="filtroDataSelecionado" (selectionChange)="getSearchData($event.value)">
                <mat-option value="Nao filtrar data">Não Filtrar Data</mat-option>
                <mat-option *ngFor="let opcao of opcoesDatas" [value]="opcao.value">{{opcao.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 1">
            <mat-form-field>
              <mat-label>Período do Contato</mat-label>
              <input matInput [(ngModel)]="searchDataInicialContato.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>
          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 1">
            <mat-form-field>
              <input matInput [(ngModel)]="searchDataFinalContato.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>

          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 2">
            <mat-form-field>
              <mat-label>Período de Status</mat-label>
              <input matInput [(ngModel)]="searchDataInicialStatus.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>
          <div class="col-md-5 col-sm-5" *ngIf="filtroDataSelecionado === 2">
            <mat-form-field>
              <input matInput [(ngModel)]="searchDataFinalStatus.searchTerm" type="date" max="2999-12-31">
            </mat-form-field>
          </div>

        </div>
      </div>
      <div class="footer">
        <button mat-flat-button color="primary" (click)="filter()">
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="card">
      <div class="header">
        <h2>Contato</h2>
      </div>
      <div class="body table-responsive">
        <!--query end-->
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover"
          style="width: 100%;">
          <thead>
            <tr>
              <th class="text-center" width="70">Data</th>
              <th class="text-center" width="100">Status</th>
              <th class="text-center" width="70">Data Status</th>
              <th class="text-center">Nome</th>
              <th class="text-center" width="100">Usuario Responsável</th>
              <th class="text-center" width="150"></th>
            </tr>
          </thead>
          <tbody *ngIf="models?.length != 0">
            <tr *ngFor="let contato of models">
              <td>
                {{contato.data | date :'dd/MM/yyyy'}}
              </td>
              <td>
                <span class="label" [ngClass]="typesService.getContatoStatusColor(contato.status)">
                  {{typesService.getContatoStatusType(contato.status)}}
                </span>
              </td>
              <td>
                {{contato.dataStatus | date :'dd/MM/yyyy'}}
              </td>
              <td>
                {{contato.nome}}
              </td>
              <td>
                {{contato.usuarioResponsavelNome}}
              </td>
              <td class="text-center">
                <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(contato)" matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(contato.id)" matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="fixed-action-btn">
        <button [disabled]="!isAllowed('Create')" mat-fab color="primary" (click)="create()" matTooltip="Adicionar (F9)" matTooltipPosition="above">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <app-contato-site-modal #contatoSiteModal (modalSave)="onResponse($event)"></app-contato-site-modal>
